import { alpha, Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  content: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    minWidth: 0,
  },
  section: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  sectionTitle: {
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "21px",
    color: theme.palette.secondary.main,
    textAlign: "right",
    width: "100%",
    fontFamily: "Noto Sans Hebrew",
  },
  statusRow: {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    gap: "10px",
  },
  field: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    minWidth: 0,
  },
  label: {
    fontSize: "12px",
    color: theme.palette.text.secondary,
    textAlign: "right",
    width: "100%",
    fontFamily: "Noto Sans Hebrew",
  },
  readonlyField: {
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: "4px",
    padding: "12px 16px 12px 8px",
    height: "48px",
    width: "100%",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    direction: "ltr",
  },
  statusPill: {
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "20px",
    color: theme.palette.primary.main,
    backgroundColor: alpha(theme.palette.primary.main, 0.1),
    borderRadius: "16px",
    padding: "2px 12px",
    whiteSpace: "nowrap",
    fontFamily: "Noto Sans Hebrew",
  },
  helperText: {
    fontSize: "11px",
    lineHeight: "16px",
    color: theme.palette.text.secondary,
    textAlign: "right",
    width: "100%",
    fontFamily: "Noto Sans Hebrew",
  },
  select: {
    width: "100%",
    direction: "ltr",
    height: "48px",
    minHeight: "48px",
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: "14px",
    lineHeight: "140%",
    letterSpacing: 0,
    textAlign: "right",
    verticalAlign: "middle",
    color: theme.palette.secondary.main,
    leadingTrim: "cap-height",
    backgroundColor: theme.palette.background.paper,
    borderRadius: "4px",
    opacity: 1,
    boxSizing: "border-box",
    "& fieldset, & .MuiOutlinedInput-notchedOutline": {
      borderColor: `${theme.palette.divider} !important`,
      borderWidth: "1px !important",
    },
    "&:hover fieldset, &:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: `${theme.palette.divider} !important`,
    },
    "&.Mui-focused fieldset, &.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: `${theme.palette.divider} !important`,
      borderWidth: "1px !important",
    },
    "& .MuiSelect-select": {
      height: "48px",
      minHeight: "48px",
      fontWeight: 400,
      fontStyle: "normal",
      fontSize: "14px",
      lineHeight: "140%",
      letterSpacing: 0,
      textAlign: "right",
      verticalAlign: "middle",
      color: theme.palette.secondary.main,
      leadingTrim: "cap-height",
      padding: "12px 16px 12px 8px !important",
      direction: "rtl",
      boxSizing: "border-box",
      fontFamily: "Noto Sans Hebrew",
      display: "flex",
      alignItems: "center",
    },
    "& .MuiSelect-icon": {
      color: theme.palette.text.primary,
      right: "auto",
      left: "8px",
    },
  },
  selectMenuPaper: {
    direction: "rtl",
    "& .MuiMenuItem-root": {
      direction: "rtl",
      textAlign: "right",
      justifyContent: "flex-start",
      fontFamily: "Noto Sans Hebrew",
      fontSize: "14px",
      lineHeight: "140%",
      color: theme.palette.secondary.main,
    },
  },
  divider: {
    height: "1px",
    backgroundColor: theme.palette.divider,
  },
  itemsRow: {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    gap: "10px",
  },
  itemColumn: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    minWidth: 0,
  },
  itemTitle: {
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "21px",
    color: theme.palette.secondary.main,
    textAlign: "right",
    width: "100%",
    fontFamily: "Noto Sans Hebrew",
  },
  saveButton: {
    width: "100%",
    height: "48px",
    minHeight: "48px",
    borderRadius: "4px",
    padding: "10px 16px",
    gap: "6px",
    textTransform: "none",
    fontSize: "14px",
    fontWeight: 600,
    backgroundColor: theme.palette.primary.main,
    boxShadow: "none",
    boxSizing: "border-box",
    fontFamily: "Noto Sans Hebrew",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      boxShadow: "none",
    },
  },
}));
